"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BookingType = void 0;
/**
 * FBA (Manual) : FBA Shipments are created by merchants in this case.. Details of which is provided at the time of booking
 * FBA (Automated): FBA Shipments are created by flexport via fba api
 */
var BookingType;
(function (BookingType) {
    BookingType["INTL_FREIGHT_FBA_MANUAL"] = "INTL_FREIGHT_FBA_MANUAL";
    BookingType["INTL_FREIGHT_TO_RS"] = "INTL_FREIGHT_TO_RS";
    BookingType["INTL_FREIGHT_FBA"] = "INTL_FREIGHT_FBA";
    BookingType["INT_FREIGHT_FBA_DIRECT"] = "INT_FREIGHT_FBA_DIRECT";
})(BookingType || (exports.BookingType = BookingType = {}));
//# sourceMappingURL=BookingType.js.map